import { getImpersonationToken } from 'utils/impersonation';

export const AUTH_CONFIG: { getToken: () => Promise<string | undefined> } = {
  getToken: async () => {
    return getImpersonationToken() ?? undefined;
  },
};
